import { SET_ACCOUNTING_FIELDS } from '@Actions/accountingFields';
export const defaultState = {
    accountingFields: []
};
export function accountingFieldsReducer(state = defaultState, action) {
    switch (action.type) {
        case SET_ACCOUNTING_FIELDS:
            return Object.assign(Object.assign({}, state), { accountingFields: action.payload });
        default:
            return state;
    }
}
